import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LoadingAction } from 'src/app/shared/models/loading-action.enum';
import { LiabilityActions } from '../../../../liabilities/classes/liability-actions';
import { Liability } from '../../../../liabilities/models/liability.model';
import { TypeformService } from 'src/app/shared/services/typeform.service';
import { LiabilityApiService } from '../../../../liabilities/services/liability-api.service';
import { LiabilityItemService } from '../../../../liabilities/services/liability-item.service';
import { AppConfig } from '../../../../core/services/app-config.service';
import { LoadingService } from '../../../services/loading.service';
import { LiabilityService } from '../../../../liabilities/services/liability.service';
import { PaymentService } from '../../../../pay/services/payment.service';
import { AnalyticsService } from '../../../../core/services/analytics-service';
import { XsellService } from '../../../../billers/services/xsell.service';
import { DialogService } from '../../../../core/services/dialog.service';
import { CartStoreService } from '../../../services/cart.service';
import { IconComponent } from '../../icon/icon.component';
import { MatIconButton } from '@angular/material/button';
import { ApiCallLoadingDirective } from '../../../directives/api-call-loading.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { AsyncPipe, NgIf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-liability-expandable-menu-table',
  styleUrls: ['./liability-expandable-menu.component.scss'],
  templateUrl: './liability-expandable-menu.component.html',
  imports: [
    IconComponent,
    MatIconButton,
    ApiCallLoadingDirective,
    MatTooltip,
    RouterLink,
    AsyncPipe,
    NgIf,
  ],
})
export class LiabilityExpandableMenuComponent extends LiabilityActions implements OnChanges, OnInit {
  @ViewChild('downloadPdfLink') public downloadPdfLink: ElementRef;
  public showMenu = false;

  @Input() public disabled: boolean;
  @Input() public startedPaymentId: string = null
  @Input() public liability: Liability = null
  @Output() public liabilityMarkedAsPaidEvent = new EventEmitter<void>();

  public loadingAction = LoadingAction;

  constructor(
    public loadingService: LoadingService,
    router: Router,
    liabilityService: LiabilityService,
    paymentService: PaymentService,
    analyticsService: AnalyticsService,
    xsellService: XsellService,
    dialog: DialogService,
    snackbar: MatSnackBar,
    route: ActivatedRoute,
    typeformService: TypeformService,
    liabilityApiService: LiabilityApiService,
    liabilityItemService: LiabilityItemService,
    appConfig: AppConfig,
    cartStoreService: CartStoreService
  ) {
    super(
      liabilityService,
      paymentService,
      analyticsService,
      xsellService,
      dialog,
      snackbar,
      router,
      route,
      typeformService,
      liabilityApiService,
      liabilityItemService,
      appConfig,
      cartStoreService
    );
  }

  public ngOnInit(): void {
    this.calculateActions();
  }

  public ngOnChanges(): void {
    this.calculateActions();
  }

  public canShowDetails(): boolean {
    return true;
  }

  public showMenuClick() {
    this.showMenu = true;
  }

  public hideMenuClick() {
    this.showMenu = false;
  }
}
